import React from 'react'
import { CommonSvgContent } from "./CommonSvgContent"
import { ContentLanding } from "./ContentLanding"
import { Balloon } from "./Balloon"


export const Room7 = (props) => {

  const stars = [];
  for (let i = 0; i < 60; i++) {
    stars.push(<div className="star" key={i}  />);
  }

    return(
      <div className="pages room7">
        {stars}
        <div className="content">
          <h2><strong>CONGRATULAZIONI!</strong></h2>
          <h3>IL MISTERO È RISOLTO</h3>
          <p>Ascolta il vocale che ti ha lasciato Margherita</p>
        </div>
        <div className="lettera" onClick={() => props.onChangeStep(1)}>
          <CommonSvgContent stringToRet="click" />
          <img src={require('../assets/images/letteracompleta.jpg')} alt="" />
          <div className="marge">
            <CommonSvgContent stringToRet="marge" />
          </div>
        </div>

        <div className="mars">
          <ContentLanding stringToRet="mars" />
        </div>

        <button onClick={() => props.onChangeRoom(8)} className="btn btn-danger">termina</button>

        {(props.stepnow == 1) &&
          <Balloon type="image link" room={props.room} clickon='b_lettera' button="close" interaction={true} onChangeStep={props.onChangeStep} onChangeRoom={props.onChangeRoom} />
        }
      </div>
    )
}
